import { HttpClient } from '../shared/wrappers/HttpClient';
import { Injectable } from "@angular/core";
import { UrlBuilder } from '../models/utils/url-builder.model';
import { VendorInventoryModel } from '../models/vendor-inventory/VendorInventory.model';
import { VendorInventorySearch } from '../models/vendor-inventory/VendorInventorySearch.model';
import { SearchResult } from '../models/utils/SearchResult.model';

@Injectable()
export class VendorInventoryService {
    private endPoint: String = "/vendor-inventory";

    constructor(private httpClient: HttpClient) {
    }

    async create(vendorInventory: VendorInventoryModel): Promise<VendorInventoryModel> {
        return await this.httpClient.post(this.endPoint, vendorInventory)
    }

    async getById(id: string): Promise<VendorInventoryModel> {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async edit(vendorInventory: VendorInventoryModel): Promise<VendorInventoryModel> {
        return await this.httpClient.update(`${this.endPoint}`, vendorInventory._id, vendorInventory)
    }

    async search(searchParams: VendorInventorySearch): Promise<SearchResult<VendorInventoryModel>>{
        let result = new SearchResult<VendorInventoryModel>();

        const keyParams = [
            {key: 'vendors', value: searchParams.vendors},
            {key: 'active', value: searchParams.active},
            {key: 'types', value: searchParams.types},
            {key: 'excellenceCenters', value: searchParams.excellenceCenters},
        ];

        const builder = new UrlBuilder([
            { key: "skip", value: searchParams.skip },
            { key: "limit", value: searchParams.limit },
            { key: "projectionFields", value: searchParams.projectionFields},
            ...keyParams
        ]);

        let url = builder.buildUrl(`${this.endPoint}`);
        let response = await this.httpClient.get(url);
        if (!response)
            return result;

        result.totalItems = response.totalItems;
        if (response.data)
            result.listItems.push(...response.data.map(item => new VendorInventoryModel(item)));

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/vendorInventory.service.ts